import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=b1339e0e&"
import script from "@/scripts/rating/rating.js?vue&type=script&lang=js&"
export * from "@/scripts/rating/rating.js?vue&type=script&lang=js&"
import style0 from "./Rating.vue?vue&type=style&index=0&id=b1339e0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports